import { useSignal } from "@preact/signals";
import { FC } from "preact/compat";
import { IconButton, TextField } from "~/components";
import { getChats } from "~/core/store";
import { CommentsProps } from "./interfaces";
import SendIcon from "@material-design-icons/svg/outlined/send.svg";
import Messages from "./Messages";

const Comments: FC<CommentsProps> = ({ task }) => {
    const content = useSignal("");
    const chats = getChats();
    const chat = chats.chats.value.find((chat) => chat.id === task.chatId);

    const handleSend = async () => {
        if (!chat) {
            // @TODO: we want to create a new chat here
            return;
        }

        chats.send({
            content: content.value,
            threadId: chat.rootThreadId,
        });
        content.value = "";
    };

    return (
        <div>
            <div className="flex items-center">
                <div className="w-8 min-w-[32px] h-8 mr-2 bg-gray-200 rounded-full">
                    <span />
                </div>
                <TextField
                    className="w-full"
                    placeholder="Add a comment..."
                    value={content.value}
                    onInput={({ currentTarget }) =>
                        (content.value = currentTarget.value)
                    }
                    onKeyDown={({ key }) => {
                        if (key === "Enter") {
                            handleSend();
                        }
                    }}
                />
                <IconButton onClick={handleSend} className="ml-2">
                    <SendIcon width="18" height="18" />
                </IconButton>
            </div>
            {chat ? (
                <Messages chat={chat} />
            ) : (
                <div className="text-sm text-gray-500"> No comments yet</div>
            )}
        </div>
    );
};

export default Comments;
